import React from "react";

import { useTranslation } from "react-i18next";

import { cn } from "@/src/lib/utils";

import type { JSX } from "react";

import type { BulkFlatFinding } from "./bulkFindings";
import type { BulkFindingSeverity } from "../../api/BulkAPI.types";

interface BulkValidationFindingsProps {
  findingList: BulkFlatFinding[];
}

const SEVERITY_BORDER_CLASS_NAME: Record<BulkFindingSeverity, string> = {
  error: "border-status-error",
  warning: "border-status-warning",
};

function getFindingKey(finding: BulkFlatFinding, index: number): string {
  return `${finding.language ?? "root"}-${finding.field}-${finding.code}-${finding.severity}-${index}`;
}

function BulkValidationFindings({
  findingList,
}: BulkValidationFindingsProps): JSX.Element {
  const { t } = useTranslation("editor-bulk");

  return (
    <div className="flex flex-col gap-2">
      {findingList.map((finding, index) => (
        <div
          key={getFindingKey(finding, index)}
          className={cn(
            "bg-muted flex flex-col gap-1 rounded-r-md border-l-4 p-3 text-sm",
            SEVERITY_BORDER_CLASS_NAME[finding.severity],
          )}
        >
          <p className="font-semibold">
            {finding.language ? `${finding.language} · ` : null}
            {finding.field} —{" "}
            {t(`findingCodes.${finding.code}`, { defaultValue: finding.code })}
          </p>

          {finding.valueText === null ? null : (
            <p className="text-muted-foreground">
              {t("received")} :{" "}
              <span className="text-foreground font-mono">
                {finding.valueText}
              </span>
            </p>
          )}

          {finding.expectedText === null ? null : (
            <p className="text-muted-foreground">
              {t("expected")} :{" "}
              <span className="text-foreground font-mono">
                {finding.expectedText}
              </span>
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

export default BulkValidationFindings;
